/** Small math helpers ported from supersplat-viewer/src/core/math.ts. */

/** Frame-rate-independent damping: 1 - damping^(dt*1000). */
const damp = (damping: number, dt: number) => 1 - Math.pow(damping, dt * 1000);

/** Modulus that handles negative values correctly. */
const mod = (n: number, m: number) => ((n % m) + m) % m;

export { damp, mod };
